import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastUtilService {

  constructor() { }

  position: string = 'center';

  getPosition(): string {
    return this.position;
  }
}
